import includes from 'lodash/includes';
import get from 'lodash/get';
import { View, ViewFlag } from 'common/types/view';

export default (view?: Partial<View> | null, flag?: ViewFlag): boolean =>
  includes(get(view, 'flags', []), flag);
